// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3I-oZ","modalBody":"Modal_modalBody__3sP_b"};